(function () {
    'use strict';
    var ReactIntl = require('react-intl');
    var af = require('../i18n/locale-data/af');
    var agq = require('../i18n/locale-data/agq');
    var ak = require('../i18n/locale-data/ak');
    var am = require('../i18n/locale-data/am');
    var ar = require('../i18n/locale-data/ar');
    var asjs = require('../i18n/locale-data/as');
    var asa = require('../i18n/locale-data/asa');
    var ast = require('../i18n/locale-data/ast');
    var az = require('../i18n/locale-data/az');
    var bas = require('../i18n/locale-data/bas');
    var be = require('../i18n/locale-data/be');
    var bem = require('../i18n/locale-data/bem');
    var bez = require('../i18n/locale-data/bez');
    var bg = require('../i18n/locale-data/bg');
    var bh = require('../i18n/locale-data/bh');
    var bm = require('../i18n/locale-data/bm');
    var bn = require('../i18n/locale-data/bn');
    var bo = require('../i18n/locale-data/bo');
    var br = require('../i18n/locale-data/br');
    var brx = require('../i18n/locale-data/brx');
    var bs = require('../i18n/locale-data/bs');
    var ca = require('../i18n/locale-data/ca');
    var ce = require('../i18n/locale-data/ce');
    var cgg = require('../i18n/locale-data/cgg');
    var chr = require('../i18n/locale-data/chr');
    var ckb = require('../i18n/locale-data/ckb');
    var cs = require('../i18n/locale-data/cs');
    var cu = require('../i18n/locale-data/cu');
    var cy = require('../i18n/locale-data/cy');
    var da = require('../i18n/locale-data/da');
    var dav = require('../i18n/locale-data/dav');
    var de = require('../i18n/locale-data/de');
    var dje = require('../i18n/locale-data/dje');
    var dsb = require('../i18n/locale-data/dsb');
    var dua = require('../i18n/locale-data/dua');
    var dv = require('../i18n/locale-data/dv');
    var dyo = require('../i18n/locale-data/dyo');
    var dz = require('../i18n/locale-data/dz');
    var ebu = require('../i18n/locale-data/ebu');
    var ee = require('../i18n/locale-data/ee');
    var el = require('../i18n/locale-data/el');
    var en = require('../i18n/locale-data/en');
    var eo = require('../i18n/locale-data/eo');
    var es = require('../i18n/locale-data/es');
    var et = require('../i18n/locale-data/et');
    var eu = require('../i18n/locale-data/eu');
    var ewo = require('../i18n/locale-data/ewo');
    var fa = require('../i18n/locale-data/fa');
    var ff = require('../i18n/locale-data/ff');
    var fi = require('../i18n/locale-data/fi');
    var fil = require('../i18n/locale-data/fil');
    var fo = require('../i18n/locale-data/fo');
    var fr = require('../i18n/locale-data/fr');
    var fur = require('../i18n/locale-data/fur');
    var fy = require('../i18n/locale-data/fy');
    var ga = require('../i18n/locale-data/ga');
    var gd = require('../i18n/locale-data/gd');
    var gl = require('../i18n/locale-data/gl');
    var gsw = require('../i18n/locale-data/gsw');
    var gu = require('../i18n/locale-data/gu');
    var guw = require('../i18n/locale-data/guw');
    var guz = require('../i18n/locale-data/guz');
    var gv = require('../i18n/locale-data/gv');
    var ha = require('../i18n/locale-data/ha');
    var haw = require('../i18n/locale-data/haw');
    var he = require('../i18n/locale-data/he');
    var hi = require('../i18n/locale-data/hi');
    var hr = require('../i18n/locale-data/hr');
    var hsb = require('../i18n/locale-data/hsb');
    var hu = require('../i18n/locale-data/hu');
    var hy = require('../i18n/locale-data/hy');
    var id = require('../i18n/locale-data/id');
    var ig = require('../i18n/locale-data/ig');
    var ii = require('../i18n/locale-data/ii');
    var injs = require('../i18n/locale-data/in');
    var isjs = require('../i18n/locale-data/is');
    var it = require('../i18n/locale-data/it');
    var iu = require('../i18n/locale-data/iu');
    var iw = require('../i18n/locale-data/iw');
    var ja = require('../i18n/locale-data/ja');
    var jbo = require('../i18n/locale-data/jbo');
    var jgo = require('../i18n/locale-data/jgo');
    var ji = require('../i18n/locale-data/ji');
    var jmc = require('../i18n/locale-data/jmc');
    var jv = require('../i18n/locale-data/jv');
    var jw = require('../i18n/locale-data/jw');
    var ka = require('../i18n/locale-data/ka');
    var kab = require('../i18n/locale-data/kab');
    var kaj = require('../i18n/locale-data/kaj');
    var kam = require('../i18n/locale-data/kam');
    var kcg = require('../i18n/locale-data/kcg');
    var kde = require('../i18n/locale-data/kde');
    var kea = require('../i18n/locale-data/kea');
    var khq = require('../i18n/locale-data/khq');
    var ki = require('../i18n/locale-data/ki');
    var kk = require('../i18n/locale-data/kk');
    var kkj = require('../i18n/locale-data/kkj');
    var kl = require('../i18n/locale-data/kl');
    var kln = require('../i18n/locale-data/kln');
    var km = require('../i18n/locale-data/km');
    var kn = require('../i18n/locale-data/kn');
    var ko = require('../i18n/locale-data/ko');
    var kok = require('../i18n/locale-data/kok');
    var ks = require('../i18n/locale-data/ks');
    var ksb = require('../i18n/locale-data/ksb');
    var ksf = require('../i18n/locale-data/ksf');
    var ksh = require('../i18n/locale-data/ksh');
    var ku = require('../i18n/locale-data/ku');
    var kw = require('../i18n/locale-data/kw');
    var ky = require('../i18n/locale-data/ky');
    var lag = require('../i18n/locale-data/lag');
    var lb = require('../i18n/locale-data/lb');
    var lg = require('../i18n/locale-data/lg');
    var lkt = require('../i18n/locale-data/lkt');
    var ln = require('../i18n/locale-data/ln');
    var lo = require('../i18n/locale-data/lo');
    var lrc = require('../i18n/locale-data/lrc');
    var lt = require('../i18n/locale-data/lt');
    var lu = require('../i18n/locale-data/lu');
    var luo = require('../i18n/locale-data/luo');
    var luy = require('../i18n/locale-data/luy');
    var lv = require('../i18n/locale-data/lv');
    var mas = require('../i18n/locale-data/mas');
    var mer = require('../i18n/locale-data/mer');
    var mfe = require('../i18n/locale-data/mfe');
    var mg = require('../i18n/locale-data/mg');
    var mgh = require('../i18n/locale-data/mgh');
    var mgo = require('../i18n/locale-data/mgo');
    var mk = require('../i18n/locale-data/mk');
    var ml = require('../i18n/locale-data/ml');
    var mn = require('../i18n/locale-data/mn');
    var mo = require('../i18n/locale-data/mo');
    var mr = require('../i18n/locale-data/mr');
    var ms = require('../i18n/locale-data/ms');
    var mt = require('../i18n/locale-data/mt');
    var mua = require('../i18n/locale-data/mua');
    var my = require('../i18n/locale-data/my');
    var mzn = require('../i18n/locale-data/mzn');
    var nah = require('../i18n/locale-data/nah');
    var naq = require('../i18n/locale-data/naq');
    var nb = require('../i18n/locale-data/nb');
    var nd = require('../i18n/locale-data/nd');
    var ne = require('../i18n/locale-data/ne');
    var nl = require('../i18n/locale-data/nl');
    var nmg = require('../i18n/locale-data/nmg');
    var nn = require('../i18n/locale-data/nn');
    var nnh = require('../i18n/locale-data/nnh');
    var no = require('../i18n/locale-data/no');
    var nqo = require('../i18n/locale-data/nqo');
    var nr = require('../i18n/locale-data/nr');
    var nso = require('../i18n/locale-data/nso');
    var nus = require('../i18n/locale-data/nus');
    var ny = require('../i18n/locale-data/ny');
    var nyn = require('../i18n/locale-data/nyn');
    var om = require('../i18n/locale-data/om');
    var or = require('../i18n/locale-data/or');
    var os = require('../i18n/locale-data/os');
    var pa = require('../i18n/locale-data/pa');
    var pap = require('../i18n/locale-data/pap');
    var pl = require('../i18n/locale-data/pl');
    var prg = require('../i18n/locale-data/prg');
    var ps = require('../i18n/locale-data/ps');
    var pt = require('../i18n/locale-data/pt');
    var qu = require('../i18n/locale-data/qu');
    var rm = require('../i18n/locale-data/rm');
    var rn = require('../i18n/locale-data/rn');
    var ro = require('../i18n/locale-data/ro');
    var rof = require('../i18n/locale-data/rof');
    var ru = require('../i18n/locale-data/ru');
    var rw = require('../i18n/locale-data/rw');
    var rwk = require('../i18n/locale-data/rwk');
    var sah = require('../i18n/locale-data/sah');
    var saq = require('../i18n/locale-data/saq');
    var sbp = require('../i18n/locale-data/sbp');
    var sdh = require('../i18n/locale-data/sdh');
    var se = require('../i18n/locale-data/se');
    var seh = require('../i18n/locale-data/seh');
    var ses = require('../i18n/locale-data/ses');
    var sg = require('../i18n/locale-data/sg');
    var sh = require('../i18n/locale-data/sh');
    var shi = require('../i18n/locale-data/shi');
    var si = require('../i18n/locale-data/si');
    var sk = require('../i18n/locale-data/sk');
    var sl = require('../i18n/locale-data/sl');
    var sma = require('../i18n/locale-data/sma');
    var smi = require('../i18n/locale-data/smi');
    var smj = require('../i18n/locale-data/smj');
    var smn = require('../i18n/locale-data/smn');
    var sms = require('../i18n/locale-data/sms');
    var sn = require('../i18n/locale-data/sn');
    var so = require('../i18n/locale-data/so');
    var sq = require('../i18n/locale-data/sq');
    var sr = require('../i18n/locale-data/sr');
    var ss = require('../i18n/locale-data/ss');
    var ssy = require('../i18n/locale-data/ssy');
    var st = require('../i18n/locale-data/st');
    var sv = require('../i18n/locale-data/sv');
    var sw = require('../i18n/locale-data/sw');
    var syr = require('../i18n/locale-data/syr');
    var ta = require('../i18n/locale-data/ta');
    var te = require('../i18n/locale-data/te');
    var teo = require('../i18n/locale-data/teo');
    var th = require('../i18n/locale-data/th');
    var ti = require('../i18n/locale-data/ti');
    var tig = require('../i18n/locale-data/tig');
    var tk = require('../i18n/locale-data/tk');
    var tl = require('../i18n/locale-data/tl');
    var tn = require('../i18n/locale-data/tn');
    var to = require('../i18n/locale-data/to');
    var tr = require('../i18n/locale-data/tr');
    var ts = require('../i18n/locale-data/ts');
    var twq = require('../i18n/locale-data/twq');
    var tzm = require('../i18n/locale-data/tzm');
    var ug = require('../i18n/locale-data/ug');
    var uk = require('../i18n/locale-data/uk');
    var ur = require('../i18n/locale-data/ur');
    var uz = require('../i18n/locale-data/uz');
    var vai = require('../i18n/locale-data/vai');
    var ve = require('../i18n/locale-data/ve');
    var vi = require('../i18n/locale-data/vi');
    var vo = require('../i18n/locale-data/vo');
    var vun = require('../i18n/locale-data/vun');
    var wa = require('../i18n/locale-data/wa');
    var wae = require('../i18n/locale-data/wae');
    var wo = require('../i18n/locale-data/wo');
    var xh = require('../i18n/locale-data/xh');
    var xog = require('../i18n/locale-data/xog');
    var yav = require('../i18n/locale-data/yav');
    var yi = require('../i18n/locale-data/yi');
    var yo = require('../i18n/locale-data/yo');
    var zgh = require('../i18n/locale-data/zgh');
    var zh = require('../i18n/locale-data/zh');
    var zu = require('../i18n/locale-data/zu');
    var xx = require('../i18n/locale-data/xx');

    var addLocaleData = ReactIntl.addLocaleData;

    var localeUtils = {
        initLocales() {
            addLocaleData([...af, ...agq, ...ak, ...am, ...ar, ...asjs, ...asa, ...ast, ...az, ...bas, ...be, ...bem, ...bez, ...bg, ...bh, ...bm, ...bn, ...bo, ...br, ...brx, ...bs, ...ca, ...ce, ...cgg, ...chr, ...ckb, ...cs, ...cu, ...cy, ...da, ...dav, ...de, ...dje, ...dsb, ...dua, ...dv, ...dyo, ...dz, ...ebu, ...ee, ...el, ...en, ...eo, ...es, ...et, ...eu, ...ewo, ...fa, ...ff, ...fi, ...fil, ...fo, ...fr, ...fur, ...fy, ...ga, ...gd, ...gl, ...gsw, ...gu, ...guw, ...guz, ...gv, ...ha, ...haw, ...he, ...hi, ...hr, ...hsb, ...hu, ...hy, ...id, ...ig, ...ii, ...injs, ...isjs, ...it, ...iu, ...iw, ...ja, ...jbo, ...jgo, ...ji, ...jmc, ...jv, ...jw, ...ka, ...kab, ...kaj, ...kam, ...kcg, ...kde, ...kea, ...khq, ...ki, ...kk, ...kkj, ...kl, ...kln, ...km, ...kn, ...ko, ...kok, ...ks, ...ksb, ...ksf, ...ksh, ...ku, ...kw, ...ky, ...lag, ...lb, ...lg, ...lkt, ...ln, ...lo, ...lrc, ...lt, ...lu, ...luo, ...luy, ...lv, ...mas, ...mer, ...mfe, ...mg, ...mgh, ...mgo, ...mk, ...ml, ...mn, ...mo, ...mr, ...ms, ...mt, ...mua, ...my, ...mzn, ...nah, ...naq, ...nb, ...nd, ...ne, ...nl, ...nmg, ...nn, ...nnh, ...no, ...nqo, ...nr, ...nso, ...nus, ...ny, ...nyn, ...om, ...or, ...os, ...pa, ...pap, ...pl, ...prg, ...ps, ...pt, ...qu, ...rm, ...rn, ...ro, ...rof, ...ru, ...rw, ...rwk, ...sah, ...saq, ...sbp, ...sdh, ...se, ...seh, ...ses, ...sg, ...sh, ...shi, ...si, ...sk, ...sl, ...sma, ...smi, ...smj, ...smn, ...sms, ...sn, ...so, ...sq, ...sr, ...ss, ...ssy, ...st, ...sv, ...sw, ...syr, ...ta, ...te, ...teo, ...th, ...ti, ...tig, ...tk, ...tl, ...tn, ...to, ...tr, ...ts, ...twq, ...tzm, ...ug, ...uk, ...ur, ...uz, ...vai, ...ve, ...vi, ...vo, ...vun, ...wa, ...wae, ...wo, ...xh, ...xog, ...yav, ...yi, ...yo, ...zgh, ...zh, ...zu, ...xx]);
        },
        formatMessage(intl, defaultMessages, id, text) {
            let localeText = "";
            try {
                localeText = intl.formatMessage(defaultMessages[id]);                
                return decodeURIComponent(escape(localeText));
            } catch (e) {
                if(localeText)
                    return localeText;
                if (text) {
                    return text;
                } else {
                    return id;
                }
            }
        },

        isTranslationIdAvailable(intl, defaultMessages, id) {
            let localeText = "";
            try {
                localeText = intl.formatMessage(defaultMessages[id]);                
                return true;
            } catch (e) {                
                return false;                
            }
            
        }
    }

    module.exports = localeUtils;

} ());